export default "__VITE_ASSET__Dv_L8tzU__"